import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import EliteMindUserDetail from './EliteMindUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyEliteMindUserDetail } from './companyEliteMindApi';

/**
 * Company Elite Mind → one athlete's profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CEliteMindUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Athlete Profile | Shoorah</title>
      </Helmet>
      <EliteMindUserDetail
        fetcher={fetchCompanyEliteMindUserDetail}
        backPath={`/${slug}/elite-mind/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Athletes'}
      />
    </div>
  );
};

export default CEliteMindUserDetail;
